import { SAY_AS_TYPE } from './constant.js';
import { sayAsElementToHtml } from './element-to-html.js';
import { sayAsHtmlToElement } from './html-to-element.js';
import { sayAsPlugin } from './plugin.js';
import { sayAsRenderElement } from './render-element.js';
import { sayAsSerializer } from './serializer.js';

const SayAsModule = {
  type: SAY_AS_TYPE,
  renderElement: sayAsRenderElement,
  elementToHtml: sayAsElementToHtml,
  htmlToElement: sayAsHtmlToElement,
  plugin: sayAsPlugin,
  serializer: sayAsSerializer
};

export { SayAsModule };
//# sourceMappingURL=module.js.map
